module.exports = "<p>\n  promesas works!\n</p>\n"